import { MouseEventHandler, ReactNode } from 'react';
import Text from '../../atoms/Text';
import Image from '../../atoms/Image';
import Loader from '../../components/common/Loader';

import './styles.scss';

interface IProps {
  text?: string;
  left_image?: string;
  right_image?: string;
  action: MouseEventHandler<HTMLDivElement> | undefined;
  size: 'xs' | 's' | 'm' | 'l';
  variant: 'primary' | 'secondary' | 'ghost' | 'swap_settings' | 'buy' | 'sell';
  disabled?: boolean;
  is_active?: boolean;
  loading?: boolean;

  component?: ReactNode;
}

const get_text_size = (size: 'xs' | 's' | 'm' | 'l') => {
  switch (size) {
  case 'xs':
  case 's':
    return 12;
  case 'm':
    return 14;
  case 'l':
    return 16;
  }
};

const Button = (props: IProps) => {
  const text_size = get_text_size(props.size);

  const className = `btn btn--${props.size} ${
    props.is_active ? `btn--${props.variant}--active` : ''
  } btn--${props.variant}${
    props.disabled || props.loading ? '--disabled' : ''
  }`;

  const renderContent = () => {
    if (props.loading) {
      return <Loader style={{ height: '80%', maxHeight: 38 }} />;
    }
    if (props.component) {
      return props.component;
    }
    return (
      <>
        {props.left_image && (
          <div className={`btn--${props.size}--img--left`}>
            <Image src={props.left_image} size={props.size} />
          </div>
        )}
        <Text size={text_size}>{props.text || 'Button'}</Text>
        {props.right_image && (
          <div className={`btn--${props.size}--img--right`}>
            <Image src={props.right_image} size={props.size} />
          </div>
        )}
      </>
    );
  };

  return (
    <div
      className={className}
      onClick={!props.disabled && !props.loading ? props.action : undefined}
      onMouseDown={(e) => e.preventDefault()}
    >
      {renderContent()}
    </div>
  );
};

export default Button;
